// Soundium: clicking the product-page rating (or "no reviews" placeholder) smooth-scrolls
// to the judge.me reviews section. Its Shopify wrapper id is dynamic
// (shopify-section-template--<id>__judgeme_reviews), so we match by id-contains.
(function () {
  if (window.__sndReviewScroll) return;
  window.__sndReviewScroll = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.rating-link, .rating-empty');
    if (!trigger) return;
    var target =
      document.querySelector('[id*="judgeme_reviews"]') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.getElementById('reviews');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
